import React from 'react'
import { Box, Chip } from '@mui/material'
import Txt from './Txt'
import { Category } from '../utils/category'
import { formatCents } from '../utils/price'

type Product = Category['products'][number]
type Option = Product['variants'][number]['optionGroups'][number]['options'][number]

const sxCard = {
	bgcolor: 'white',
	borderRadius: '0.75rem',
	p: '1rem',
	boxShadow: 1,
} as const
// Abgeschaltete Artikel bekommen Kunden nicht zu sehen.
const sxCardMuted = { ...sxCard, bgcolor: '#ededed', opacity: 0.65 } as const
const sxDisabledChip = { flexShrink: 0, mt: '0.25rem' } as const
const sxTitleRow = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-start',
	justifyContent: 'space-between',
	gap: '0.5rem',
} as const
const sxTitleText = { flex: 1, minWidth: 0 } as const

// Ein Produkt oder eine Option. Artikel sind unveränderlich; abschalten kann sie das Restaurant
// in der Webapp, dann sind sie für Kunden nicht mehr bestellbar.
const MenuItemTile = React.memo(
	({ product, option }: { product?: Product; option?: Option }): JSX.Element | null => {
		const entity = product ?? option

		return !entity ? null : (
			<Box sx={entity.isDisabled ? sxCardMuted : sxCard}>
				<Box sx={sxTitleRow}>
					<Txt variant="h6" fontWeight="bold" sx={sxTitleText}>
						{entity.name}
					</Txt>
					{entity.isDisabled ? <Chip label="Abgeschaltet" size="small" sx={sxDisabledChip} /> : null}
				</Box>
				{product?.description ? (
					<Txt variant="body2" color="text.secondary" mt="0.25rem">
						{product.description}
					</Txt>
				) : null}
				<Txt variant="body1" fontWeight="bold" mt="0.5rem">
					{entity.priceLabel || formatCents(entity.priceInCents)}
				</Txt>
			</Box>
		)
	}
)

MenuItemTile.displayName = 'MenuItemTile'

export default MenuItemTile
